import { useTranslation } from 'react-i18next'
import { BooleanCard } from './boolean-card.component'

export function BooleanConditionList() {
  const { t } = useTranslation()

  return (
    <div className="c-flex c-flex-col c-gap-4 c-animate-fade-in c-p-4 c-border-t c-border-grey-400 c-w-full">
      <BooleanCard
        label={t('pages.configuration.followups.chatbot.conditional-sections.boolean-yes')}
        conditionKey="yes"
      />
      <BooleanCard
        label={t('pages.configuration.followups.chatbot.conditional-sections.boolean-no')}
        conditionKey="no"
      />
    </div>
  )
}
